import { CheckCircle, FiberManualRecord } from '@mui/icons-material';
import {
  Box,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  styled,
  Typography
} from '@mui/material';
import { makeStyles as createMakeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';

//import { makeStyles } from '@material-ui/core/styles';
//import BillingInformation from '../BillingInformationComponent/BillingInformation';
//import ShippingInformation from '../ShippingInformationComponent/ShippingInformation';
//import RequestersInformationComponent from '../RequestersInformationComponent/RequestersInformationComponent';
//import TesTBill from '../BillingInformationComponent/BillingInformation';
//import Test from '../BillingInformationComponent/BillingInformation';

interface StepperComponentProps {

  currentStep: number;

  steps: string[];

}

const DottedConnector = styled(StepConnector)(({ theme }) => ({
  '& .MuiStepConnector-line': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 2,
    color: theme.palette.primary.main,
    borderTop: 'none !important',
    '&::before': {
      content: '"•••••••••••••••"',
      fontSize: 16,
      color: '#91989f',
    },
  }
}));

const useStyles = createMakeStyles({
  activeStepLabel: {
    color: '#0162DD !important',
    fontFamily: 'Inter !important',
    fontSize: '13px !important',
    fontWeight: 400,
    lineHeight: '15.73px !important',
    textAlign: 'center',
    textUnderlinePosition: 'from-font !important',
    textDecorationSkipInk: 'none'
  },

  inactiveStepLabel: {
    color: '#465668 !important',
    fontFamily: 'Inter !important',
    fontSize: '13px !important',
    fontWeight: 400,
    lineHeight: '15.73px !important',
    textAlign: 'center',
    textUnderlinePosition: 'from-font !important',
    textDecorationSkipInk: 'none'
  },
});

// const steps = [
//   'Billing Information',
//   'Requester Information',
//   'Shipping Information',
//   'Receiving Information',
//   'Product Information',
// ];

const CustomStepper: React.FC<StepperComponentProps> = ({ currentStep, steps }) => {
  const [activeStep, setActiveStep] = useState(currentStep);
  const classes = useStyles();

  useEffect(() => {
    setActiveStep(currentStep);
  }, [currentStep]);


  const renderIcon = (index: number) => {
    const stepNumber = (index + 1).toString().padStart(2, '0');
    if (activeStep === index) {
      return (
        <div style={{
          width: '25px',
          height: '25px',
          borderRadius: '50%',
          border: '1px solid blue',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#0162DD',
        }}>
          <FiberManualRecord sx={{ fontSize: '16px', color: '#0162DD' }} />
        </div>
      );
    } else if (activeStep > index) {
      return (
        <div>
          <CheckCircle sx={{
            width: '25px',
            height: '25px', color: 'grey', backgroundColor: 'white', borderRadius: '50%'
          }} />
        </div>
      );
    } else {
      return (
        <div style={{
          width: '25px',
          height: '25px',
          borderRadius: '50%',
          border: '1px solid grey',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <Typography variant="body1" style={{
            position: 'absolute',
            color: 'grey',
            fontSize: '14px',
          }}>
            {stepNumber}
          </Typography>
        </div>
      );
    }
  };

  return (
    <Box sx={{ width: '100%', backgroundColor: 'white', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', overflow: 'none' }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexGrow: 0, marginTop: '0px' }}>
        <Stepper sx={{ width: '674px', top: '0px' }} activeStep={activeStep} alternativeLabel connector={<DottedConnector />}>
          {steps.map((label, index) => (
            <Step key={label} sx={{ paddingTop: '10px' }}>
              <StepLabel icon={renderIcon(index)}>
                <span className={activeStep === index ? classes.activeStepLabel : classes.inactiveStepLabel}>
                  <Typography sx={{ font: 'normal normal 12px Segoe UI', width: index === 4 ? '7rem' : '5rem', marginLeft: index !== 4 ? '20px' : '0px' }}> {label}</Typography>
                </span>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
    </Box>
  );
};

export default CustomStepper;